import React from 'react';
import {
  Box,
  Card,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material';
import MobiledataOffIcon from '@mui/icons-material/MobiledataOff';

const BreakdownTable = ({ data = [] }) => {
  if (!data || data.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 2
        }}>
        <MobiledataOffIcon sx={{ fontSize: '40px', color: '#3A3A3A', mr: 1 }} />
        <Typography variant="h6" sx={{ color: '#3A3A3A' }}>
          No Data Found
        </Typography>
      </Box>
    );
  }

  // Extract headers dynamically from the first object
  const headers = Object.keys(data[0] || {});

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', mt: 1 }}>
      <Card
        sx={{
          width: '100%',
          background: '#FBFCFE',
          ml: 1,
          border: '1px solid #D7E5F8',
          overflowX: 'auto'
        }}>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  key={`${index + 1}`}
                  sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, rowIndex) => (
              <TableRow key={`${rowIndex + 1}`}>
                {headers.map((header, colIndex) => (
                  <TableCell key={`${colIndex + 1}`}>
                    {row[header] === 'null' || row[header] === '' ? '--' : row[header]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Box>
  );
};

export default BreakdownTable;
